import { ApiService } from '../abstract/api-service.abstract';
import { inject, Injectable } from '@angular/core';
import { LangService } from './lang.service';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { AnnouncementModel } from '../models/announcement.models';

export interface NewsListDto {
  title?: string;
  createdAfter?: string;
  createdBefore?: string;
  skip?: number;
  take?: number;
  orderBy?: string;
  orderDirection?: 'ASC' | 'DESC';
}

@Injectable({
  providedIn: 'root',
})
export class NewsService extends ApiService {
  private langService: LangService = inject(LangService);

  getNewsList(
    params: NewsListDto = {},
  ): Observable<{ count: number; data: AnnouncementModel[] }> {
    let httpParams = new HttpParams();

    if (params.title) {
      httpParams = httpParams.set('title', params.title);
    }
    if (params.createdAfter) {
      httpParams = httpParams.set('createdAfter', params.createdAfter);
    }
    if (params.createdBefore) {
      httpParams = httpParams.set('createdBefore', params.createdBefore);
    }
    if (params.skip !== undefined) {
      httpParams = httpParams.set('skip', params.skip.toString());
    }
    if (params.take !== undefined) {
      httpParams = httpParams.set('take', params.take.toString());
    }
    if (params.orderBy) {
      httpParams = httpParams.set('orderBy', params.orderBy);
    }
    if (params.orderDirection) {
      httpParams = httpParams.set('orderDirection', params.orderDirection);
    }

    const url = `${this.apiFrontUrl}/news/list?date=${this.cacheUid()}`;

    return this.http
      .get<{ count: number; data: any[] }>(url, { params: httpParams })
      .pipe(
        map((data) => ({
          count: data.count,
          data: data.data.map((item) => AnnouncementModel.fromJson(item)),
        })),
      );
  }

  getNewsByAlias(alias: string): Observable<AnnouncementModel> {
    return this.http.get<AnnouncementModel>(
      `${this.apiFrontUrl}/news/${alias}?date=${this.cacheUid()}`,
    );
  }

  getTopNews(id: string): Observable<AnnouncementModel[]> {
    return this.http.get<AnnouncementModel[]>(
      `${this.apiFrontUrl}/news/top?date=${this.cacheUid()}`,
      { params: { id } },
    );
  }

  createNewsSupport(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiFrontUrl}/news-support`, formData);
  }
}
